import { Injectable } from '@angular/core';
import {
  adaptUserProfile,
  adaptUserProflileRequest,
} from '../../lib/apis/user-profile/adapt-user-profile';
import { UserProfileApi } from '../../lib/apis/user-profile/user-profile.api';
import { UserProfile } from '../../models/user-profile/user-profile';
import { firstValueFrom } from '../../utils/first-value-from';

@Injectable({ providedIn: 'root' })
export class UserProfileRepository {
  constructor(private readonly api: UserProfileApi) {}

  async get(key: string): Promise<UserProfile | null> {
    const res = await firstValueFrom(this.api.get(key));
    if (res === undefined) {
      return null;
    }
    return adaptUserProfile(res);
  }

  async set(key: string, userProfile: UserProfile): Promise<void> {
    const req = adaptUserProflileRequest(userProfile);
    await this.api.set(key, req);
  }

  async update(key: string, userProfile: UserProfile): Promise<void> {
    const req = adaptUserProflileRequest(userProfile);
    await this.api.update(key, req);
  }
}
